module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/division/division-detail/division-detail.component.css
// module id = ./src/app/admin/lookup-management/division/division-detail/division-detail.component.css
// module chunks = main